export class SetDebugMode {
    public static readonly type = '[RootState] Set debug mode';

    constructor(public isDebugMode: boolean = false) {}
}
